import { ICategoryMetric } from './ICategoryMetric';

export interface ICoreUser {
  openAlertsNotAssigned: number;
  openAlertsWithoutResponse: number;
  allAlertCount: number;
  alertCount: number; // count of open alerts
  currentTermOpenAlertCount: number;
  currentTermAlertCount: number;
  adviseeCount: number;
  advisorCount: number;
  adviseeList: string[];
  advisorList: string[];
  lastUpdated: Date;
  dateCreated: Date;
  deleted: boolean;
  role: number;
  retentionStatusId?: number;
  institutionProfileImageFilePath: string;
  profileImageFilePath: string;
  primaryEmailAddress: string;
  preferredEmailAddress: string;
  preferredFirstName: string;
  firstName: string;
  lastName: string;
  externalId: string;
  institutionId: string;
  id: string;
  oldestOpenAlert: Date;
  categoryMetrics: ICategoryMetric[];
  riskScore: string;
  riskScoreId: number;
}

export const GetCoreUserFormattedName = (
  x: ICoreUser,
  includeExternalId: boolean = true,
): string => {
  if (x === null || x.firstName === null || x.lastName === null) return '';

  let ret = `${x.preferredFirstName ?? x.firstName ?? ''}`;
  if (
    x.preferredFirstName &&
    x.firstName &&
    x.preferredFirstName !== x.firstName
  ) {
    ret += ` (${x.firstName})`;
  }
  if (x.lastName) {
    ret += ` ${x.lastName}`;
  }
  if (includeExternalId && x.externalId) {
    ret += ` - ${x.externalId}`;
  }
  return ret;
};
